import React from "react";
import { Heading, Flex, Image, Button, Alert } from "@chakra-ui/react";
import { Auth } from "aws-amplify";

// import components from "../components/AuthComponent";
// import { Authenticator } from "@aws-amplify/ui-react";
// import "@aws-amplify/ui-react/styles.css";
import "../../assets/theme.css";
import arupRedLogo from "../../assets/arup_red.svg";
// import Instructions from "../../components/UIElements/Instructions";

const Login = () => {
  const handleArupSignIn = async () => {
    try {
      await Auth.federatedSignIn({
        customProvider: "ArupSSO",
      });
    } catch (error) {
      console.error("Unable to start Arup SSO sign-in:", error);
    }
  };

  return (
    <Flex direction="column" alignItems="center">
      <Heading as="h2" size="lg" textAlign="center" mb="1em" mt="0.7em">
        Arup TY Programme Booking App
      </Heading>
      <Image
        src={arupRedLogo}
        height="3em"
        textAlign="center"
        mb="80px"
        mr="1em"
      />
      <Alert status="info" mb="50px" maxWidth="400px">
        <p>
          The TY Programme is not accepting self-registrations from outside Arup this year. Only users with an Arup SSO account can register and access the programme.
        </p>
      </Alert>

      <Button
        onClick={handleArupSignIn}
        width="100%"
        maxWidth="400px"
        mb="50px"
        variant="outline"
        colorScheme="red"
      >
        Sign in with your Arup Account (SSO)
      </Button>

      {/* <Authenticator
        formFields={components.formFields}
        components={components.components}
      />
      <Instructions /> */}

    </Flex>
  );
};

export default Login;
